import { createContext } from "react";

export const ClienteContext = createContext();
export const ServerContext = createContext();